import { render, staticRenderFns } from "./transfer_lead_form.vue?vue&type=template&id=454936b6"
import script from "./transfer_lead_form.vue?vue&type=script&lang=js"
export * from "./transfer_lead_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports